/**
 * t696u: My checklists' compact "Start a checklist": a tile per live checklist (not registers) you can start at one of
 * your buildings. One building starts straight away; several open a searchable sheet (t695u). Hidden without start
 * permission or when there are none.
 */
import { useQuery } from '@tanstack/react-query';
import { Play } from 'lucide-react';
import { startableChecklists } from '@tradeoutlet/shared';
import { api } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';
import { useCanAnywhere, useLocationsWith } from '@/lib/permissions';
import { useWfLookups } from '@/features/workforce/common';
import { opsKeys } from '@/features/ops/common';
import { useStartChecklist } from '@/features/ops/StartChecklist';
import { BottomSheet } from './BottomSheet';

export function MobileStartChecklists() {
  const ws = useWorkspaceId();
  const can = useCanAnywhere('ops.checklist.schedule.manage');
  const templates = useQuery({ queryKey: opsKeys(ws ?? '', 'templates'), queryFn: () => api.ops.checklistTemplates(ws!, { archived: true }), enabled: Boolean(ws && can) });
  const { locations } = useWfLookups();
  const allowed = useLocationsWith('ops.checklist.schedule.manage');
  const starter = useStartChecklist(p => (
    <BottomSheet open={p.open} onClose={p.onClose} title={p.title} testId="m-start-checklist-sheet"><div className="px-4 pb-4">{p.children}</div></BottomSheet>
  ));
  const list = can ? startableChecklists(templates.data ?? [], locations, allowed) : [];
  if (!list.length) return null;
  return (
    <section className="border-b border-slate-200 px-4 py-3 dark:border-slate-800" aria-labelledby="m-start-checklist-heading" data-testid="m-todo-start-checklist">
      <h2 id="m-start-checklist-heading" className="mb-2 text-sm font-semibold text-slate-700 dark:text-slate-200">Start a checklist</h2>
      <div className="grid grid-cols-2 gap-2">
        {list.map(t => (
          <button key={t.id} type="button" disabled={Boolean(starter.busy)} onClick={() => void starter.start(t)} data-testid="m-todo-start-template"
            className="flex min-h-11 items-center gap-2 rounded-xl border border-slate-300 px-3 py-2 text-left text-sm font-medium text-slate-800 active:bg-slate-100 disabled:opacity-60 dark:border-slate-700 dark:text-slate-100 dark:active:bg-slate-800">
            <Play className="h-4 w-4 shrink-0 text-slate-500" aria-hidden /><span className="line-clamp-2">{t.name}</span>
          </button>
        ))}
      </div>
      {starter.picker}
    </section>
  );
}
